module.exports = __webpack_public_path__ + "img/Group 97.dc92d5ed.jpg";